import { render, staticRenderFns } from "./modalAddBusinessMember.vue?vue&type=template&id=0da8c148&"
import script from "./modalAddBusinessMember.vue?vue&type=script&lang=js&"
export * from "./modalAddBusinessMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports